import { rootApi } from '../user/api';
// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['CallingSheet'],
});
export const callingsheetApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllCallingSheets: builder.query({
      query: () => `callingsheetsnew/`,
      providesTags: ['CallingSheet'],
    }),
    findAllInvalidCallingSheets: builder.query({
      query: () => `callingsheetsnew/?is_valid=false`,
      providesTags: ['CallingSheet'],
    }),

    findAllCallingSheetsByPagination: builder.query({
      query: (payload) => {
        let url = `callingsheetsnew/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['CallingSheet'],
    }),

    findAllCallingSheetsBySelection: builder.query({
      query: (payload) => {
        let url = `callingsheetsnew/selection_data/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
    }),

    findAllNumberCalling: builder.query({
      query: (payload) => {
        let url = `callingsheetsnew/number_calling/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['CallingSheet'],
    }),

    findCallingSheetById: builder.query({
      query: (id) => `callingsheetsnew/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'CallingSheet', id: result.id }]
          : ['CallingSheet'];
      },
    }),
    findCallingSheetByNo: builder.query({
      query: (no) => `callingsheetsnew/scan_at_yardout/?callingsheet_no=${no}`,
      providesTags: ['CallingSheet'],
    }),
    getCallingCompleteCount: builder.query({
      query: () => {
        let url = `callingsheets/count_calling_complete/`;
        return { url };
      },
      keepUnusedDataFor: 0,
      providesTags: ['CallingSheet'],
    }),
    createCallingSheet: builder.mutation({
      query: (region) => ({
        url: `callingsheets/`,
        method: 'POST',
        body: region,
      }),
      invalidatesTags: ['CallingSheet'],
    }),
    updateCallingSheet: builder.mutation({
      query: (region) => ({
        url: `callingsheets/${region.id}/`,
        method: 'PATCH',
        body: region,
      }),
      invalidatesTags: ['CallingSheet'],
    }),
    deleteCallingSheet: builder.mutation({
      query: (region) => ({
        url: `callingsheets/${region.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CallingSheet'],
    }),
    updateCallingVehicleStatus: builder.mutation({
      query: (payload) => ({
        url: `callingsheets/vehicle_status/?callingsheet_no=${payload.callingsheet_no}&vehicle_status=${payload.vehicle_status}`,
        method: 'PUT',
      }),
      invalidatesTags: ['CallingSheet'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllCallingSheetsQuery,
  useFindAllInvalidCallingSheetsQuery,
  useFindCallingSheetByIdQuery,
  useGetCallingCompleteCountQuery,
  useFindCallingSheetByNoQuery,
  useCreateCallingSheetMutation,
  useUpdateCallingSheetMutation,
  useDeleteCallingSheetMutation,
  useUpdateCallingVehicleStatusMutation,
} = callingsheetApi;
